import globals from '../globals'
import {css} from '../functions'
const styleSheet = new CSSStyleSheet({ media: 'screen' })

styleSheet.replace(css`
  :root {
    /* typography */
    --font-family: 'Source Sans Pro', serif;
    --font-weight: 400;
    --font-size: 1.1111111111111112rem;
    --font-size-min: 16px;
    --font-size-max: 19px;

    /* layout */
    --layout-line-height: 1.66666666rem;
    --layout-grid-columns: 12;
    --layout-grid-columns-gap: var(--layout-line-height);
    --layout-grid-rows-gap: var(--layout-line-height);
    --layout-block-spacing: calc(var(--layout-grid-rows-gap) * 3);
    --layout-block-width-default: 77.5rem;
    --layout-block-width-wide: calc(100% - 6.66666666rem);

    /* colors */
    --color-black: rgb(0, 0, 0);
    --color-white: rgb(255, 255, 255);

    --color-a: #000;
    --color-a-rgb: 0, 0, 0;
    --color-b: #fff;
    --color-b-rgb: 255, 255, 255;
    --color-c: #004467;
    --color-c-rgb: 0, 68, 103;
    --color-c-shade-1: #003d5d; /* https://maketintsandshades.com/#004467 */
    --color-c-shade-2: #003652; /* https://maketintsandshades.com/#004467 */
    --color-d: #E5E5E5;
    --color-e: #1b998b;
    --color-f: #ffbb44;
    --color-g: #f4f4f4;
    --color-h: #EF7D00;
    --color-i: #484848;
    --color-text: var(--color-a);
    --color-text-alt: var(--color-b);

    --plyr-color-main: var(--color-c);

    /* timing functions */
    --ease-in-quad: cubic-bezier(.55, .085, .68, .53);
    --ease-in-cubic: cubic-bezier(.550, .055, .675, .19);
    --ease-in-quart: cubic-bezier(.895, .03, .685, .22);
    --ease-in-quint: cubic-bezier(.755, .05, .855, .06);
    --ease-in-expo: cubic-bezier(.95, .05, .795, .035);
    --ease-in-circ: cubic-bezier(.6, .04, .98, .335);

    --ease-out-quad: cubic-bezier(.25, .46, .45, .94);
    --ease-out-cubic: cubic-bezier(.215, .61, .355, 1);
    --ease-out-quart: cubic-bezier(.165, .84, .44, 1);
    --ease-out-quint: cubic-bezier(.23, 1, .32, 1);
    --ease-out-expo: cubic-bezier(.19, 1, .22, 1);
    --ease-out-circ: cubic-bezier(.075, .82, .165, 1);

    --ease-in-out-quad: cubic-bezier(.455, .03, .515, .955);
    --ease-in-out-cubic: cubic-bezier(.645, .045, .355, 1);
    --ease-in-out-quart: cubic-bezier(.77, 0, .175, 1);
    --ease-in-out-quint: cubic-bezier(.86, 0, .07, 1);
    --ease-in-out-expo: cubic-bezier(1, 0, 0, 1);
    --ease-in-out-circ: cubic-bezier(.785, .135, .15, .86);
  }

  @media ${globals.mediaQueries.small} {
    :root {
      --layout-line-height: 3.33333332rem;
    }
  }
`)

export default styleSheet
